import { faker } from '@faker-js/faker';

import type { SendSubscriptionFormPostResponse } from '../types/SendSubscriptionFormPostResponse';

export function createSendSubscriptionFormPostResponse(
  data: NonNullable<Partial<SendSubscriptionFormPostResponse>> = {}
): NonNullable<SendSubscriptionFormPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
